import React, { useEffect, useState } from 'react';
import Loading from '../Shared/Loading';

import PortfolioCard from './PortfolioCard';

const POrtfolio = () => {
    const [portfolios,setPortfolios]= useState([])
    const [loading,setLoading]= useState(false)
   console.log(portfolios)
    useEffect(()=>{

        fetch('https://personal-portfolio-server-lovat.vercel.app/portfolio')
        .then(res=>res.json())
        .then(data=>{setPortfolios(data)
        setLoading(true)
        })
          },[])
        
          if(!loading) {
             return <Loading/>
          }
        

    return (
        <div className='min-h-screen w-full'>
            <div className="portfolio-body px-10 py-20">
                <div className="portfolio"
                 data-aos="zoom-in"data-aos-duration="1500"
                >
                <h1 className='text-5xl text-white font-extrabold uppercase mb-20'>My Awesome
                 <span className='text-primary'> Projects</span>
                 </h1>

                {/* my awesome projects card */}

                <div className="grid  md:grid-cols-2 lg:grid-cols-2 gap-5">

{
    portfolios.map(portfolio=>  <PortfolioCard
    key={portfolio._id}
    portfolio={portfolio}
    />)
}


                   
                   

                </div>



                </div>
            </div>
        </div>
    );
};

export default POrtfolio;